import {
  faUser, faArrowCircleLeft, faCheckCircle,
  faSearch, faFileAlt, faQuestion, faHome,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import Vue from 'vue';
import firebase from '@firebase/app';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import './registerServiceWorker';
import store from './store';
import router from './router';

library.add(faUser, faArrowCircleLeft,
  faCheckCircle, faSearch, faFileAlt,
  faQuestion, faHome, faTimesCircle);
Vue.component('font-awesome-icon', FontAwesomeIcon);

if (typeof firebase === 'undefined') throw new Error('hosting/init-error: Firebase SDK not detected. You must include it before /__/firebase/init.js');
firebase.initializeApp({
  apiKey: 'AIzaSyCx3KRUsN4Sg-zEw7zTNDJf1CHzB5IH_b0',
  databaseURL: 'https://duskhelm.firebaseio.com',
  storageBucket: 'duskhelm.appspot.com',
  authDomain: 'duskhelm.firebaseapp.com',
  messagingSenderId: '705176192321',
  projectId: 'duskhelm',
});

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
